export default "__VITE_PUBLIC_ASSET__06083213__"